import React, { Component } from 'react';

export default class Products extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return[
            <div className="eae-products-wrapper">
                <div className={'AePro'}>
                    <h2 className={'eae-product-title'}>AnyWhere Elementor Pro</h2>
                    <div className={'eae-ae-buttons'}>
                        <a href="http://bit.ly/2V7Ihw8" target="_blank" className={'ae-leanmore'}>Learn More</a>
                        <a href="http://bit.ly/2GTxDio" target="_blank" className={'ae-demo'}>See Demo</a>
                    </div>

                    <div className={'eae-product-content-wrapper'}>
                        <div className={'eae-product-content'}>
                            <p>Supercharge your Elementor with the ability to design global layouts

                            </p>
                            <ul>
                                <li>Design global single post layouts</li>
                                <li>Design layout for Blog Page</li>
                                <li>Design layouts for Post Type Archives, Category/Custom Taxonomy Archives</li>
                                <li>Get the ability to design layouts for Author Archives, Search Page and 404 Pages</li>
                                <li>Use data from custom fields in your Elementor Layouts</li>
                                <li>Support many field types of ACF &amp; Pods</li>
                                <li>Design WooCommerce Product, Shop and Category page layouts.</li>
                            </ul>
                        </div>
                        <div className={'eae-product-logo'}>
                            <img height={'200px'} width={'200px'} src={eaeGlobalVar.eae_dir+'assets/aep.png'} />
                        </div>
                    </div>
                </div>
            </div>

            ]
    }
}
